export function children(node) {
    switch (node.kind) {
        case 'unary':
            return [node.operand];
        case 'binary':
        case 'coalesce':
            return [node.left, node.right];
        case 'cond':
            return [node.test, node.then, node.else];
        case 'call':
            return [...node.args, ...node.named.map((n) => n.value)];
        default:
            return [];
    }
}
/** This node with each direct child replaced by `map`'s result. */
export function mapChildren(node, map) {
    switch (node.kind) {
        case 'unary':
            return { ...node, operand: map(node.operand) };
        case 'binary':
        case 'coalesce':
            return { ...node, left: map(node.left), right: map(node.right) };
        case 'cond':
            return { ...node, test: map(node.test), then: map(node.then), else: map(node.else) };
        case 'call':
            return { ...node, args: node.args.map(map), named: node.named.map((n) => ({ name: n.name, value: map(n.value) })) };
        default:
            return node;
    }
}
export function withSpan(node, span) {
    return { ...node, span };
}
/** Nesting depth, the root counting as one. */
export function depth(node) {
    return 1 + Math.max(0, ...children(node).map(depth));
}
/** Number of nodes in this subtree, this one included. */
export function countNodes(node) {
    return 1 + children(node).reduce((sum, child) => sum + countNodes(child), 0);
}
export function numIsInteger(node) {
    return !node.value.includes('.');
}
/** Digits after the decimal point; the literal's own scale (§4.5). */
export function numScale(node) {
    return numIsInteger(node) ? 0 : node.value.length - node.value.indexOf('.') - 1;
}
/** The literal `0` in any spelling (`0`, `0.00`): the one Plain operand an additive value type accepts. */
export function isZeroLiteral(node) {
    return node.kind === 'num' && /^[0.]+$/.test(node.value);
}
export function pathText(node) {
    return node.path.join('.');
}
